import { render, staticRenderFns } from "./TrabalhoRemuneracao.vue?vue&type=template&id=e02530e2"
import script from "./TrabalhoRemuneracao.vue?vue&type=script&lang=js"
export * from "./TrabalhoRemuneracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports